import { Middleware } from '@reduxjs/toolkit';

// interface ReduxAction<T = any> {
//   type: string;
//   payload?: T;
// }

// const nonSerializationMiddleware: Middleware = () => (next) => (action: ReduxAction) => {
//   // Check if the action payload contains a class instance
//   if (action.payload instanceof TimeStampTopic) {
//     console.warn('Non-serializable value detected in action payload:', action.payload);
//     // Convert the class instance to a plain object
//     action.payload = { ...action.payload };
//   }

//   // Pass the action to the next middleware or reducer
//   return next(action);
// };

const middleware: Middleware[] = [
  // nonSerializationMiddleware,
  // Add other middlewares here, e.g., redux-logger
  // createLogger({...})
];

export default middleware;
